import { EventEmitter } from "@angular/core";

export class ObservableArray<T> {
    private _collection : T[];
    private _onAdd = new EventEmitter<T[]>();

    push(...t: T[]){
        t.forEach(item => this._collection.push(item));
        this._onAdd.emit(this._collection);
    }

    remove(t: T){
        this._collection = this._collection.filter(i => i !== t);
        this._onAdd.emit(this._collection);
    }
    
    get collection(){
        return this._collection;
    }
    
    constructor(collection? : T[], onAdd? : (t : T[]) => any){
        this._collection = collection || [];
        this._onAdd.subscribe(onAdd);
    }
}
